import script from "./OccupancyChart.vue?vue&type=script&setup=true&lang=js"
export * from "./OccupancyChart.vue?vue&type=script&setup=true&lang=js"

import "./OccupancyChart.vue?vue&type=style&index=0&id=1089df36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1089df36"]])

export default __exports__